<template>
  <b-sidebar id="add-edit-class-sidebar" :visible="isAddEditClassSidebarActive" bg-variant="white"
    sidebar-class="sidebar-lg" shadow backdrop no-header right @hidden="resetForm"
    @change="(val) => $emit('update:is-add-edit-class-sidebar-active', val)">
    <template #default="{ hide }">
      <div class="
          d-flex
          justify-content-between
          align-items-center
          content-sidebar-header
          px-2
          py-1
        ">
        <h5 class="mb-0">Edit Grade</h5>
        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
      </div>
      <zape-gallery-model :props_hideShowModel="showImageModel" @modelClose="modelClose"
        @saveCategoryImage="saveImage" />
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-form class="p-2" @submit.prevent="handleSubmit(onSubmit)" @reset.prevent="resetForm">
          <validation-provider #default="validationContext" name="Edit Grade" rules="required">
            <b-form-group label="Edit Grade" label-for="Edit Grade">
              <b-form-input id="Edit-Grade" v-model="ClassData.class_name" autofocus
                :state="getValidationState(validationContext)" trim />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <br />
          <img style="width: 200px; height: 150px" :src="ClassData.class_img" alt="grade" />
          <br />
          <br />
          <div class="d-flex gap-2">
            <b-button variant="primary" @click="showgalleryimage">
              <span class="d-none d-sm-inline">Image gallery</span>
            </b-button>
            <upload-image @saveUploadImage="saveUploadImage" />
          </div>
          <br />

          <validation-provider #default="validationContext" name="Grace Period">
            <b-form-group label="Grace Period" label-for="Grace-Period">
              <b-form-input
                id="Grace-Period"
                v-model="ClassData.gracePeriod"
                type="number"
                autofocus
                :state="getValidationState(validationContext)"
                trim
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <div class="d-flex bg-light text-light align-items px-3 py-2"
            style="position: absolute; bottom: 0%; left: 0%; width: 100%">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" type="submit" @click="hide"
              :disabled="submitbutton">
              Update
            </b-button>
            <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="button" style="margin-left: 10px"
              variant="outline-secondary" @click="hide">
              Cancel
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BFormFile,
  BCol,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Ripple from "vue-ripple-directive";
import { required } from "@validations";
export default {
  components: {
    ZapeGalleryModel: () => import("../../../components/Model/ZapeGalleryModel.vue"),
    UploadImage: () => import("../../../components/Model/UploadImage.vue"),
    BSidebar,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BFormFile,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: "isAddEditClassSidebarActive",
    event: "update:is-add-edit-class-sidebar-active",
  },
  props: {
    isAddEditClassSidebarActive: {
      type: Boolean,
      required: true,
    },
    Editclassdata: {
      type: String,
      required: true,
    },
    Editclassname: {
      type: String,
      required: true,
    },
    Editclassimg: {
      type: String,
      required: true,
    },
    EditclassgracePeriod: {
      type: [String, Number],
      default: '', // ya '0'
    },
  },
  watch: {
    Editclassname() {
      this.ClassData.class_name = this.Editclassname;
    },
    Editclassimg() {
      this.ClassData.class_img = this.Editclassimg;
    },
    EditclassgracePeriod() {
      this.ClassData.gracePeriod = this.EditclassgracePeriod;
      console.log(this.ClassData.gracePeriod)
    },
  },
  data() {
    return {
      required,
      ClassData: {
        class_name: "",
        class_img: "",
        gracePeriod: null,
      },
      edit_class_data: "",
      showImageModel: false,
    };
  },
  computed: {
    submitbutton() {
      return !(
        this.ClassData.class_name.length > 0 &&
        this.ClassData.class_img.length > 0 
      );
    },
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    resetForm() {
      this.ClassData = {
        class_name: this.Editclassname,
        class_img: this.Editclassimg,
        gracePeriod: this.EditclassgracePeriod,
      };
      this.validated = false;
    },
    onSubmit() {
      this.ClassData.id = this.Editclassdata;
      this.edit_class_data = this.ClassData;
      console.log("this is data" ,this.edit_class_data)
      this.$emit("clickeditclassdata", this.edit_class_data);
    },
    saveUploadImage(url) {
      this.ClassData.class_img = url;
    },
    modelClose(modelState) {
      this.showImageModel = modelState;
    },
    saveImage(url) {
      this.ClassData.class_img = url;
    },
    showgalleryimage() {
      this.showImageModel = true;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
